import React from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarDays,
  faClock,
  faPenToSquare,
  faTrash,
  faCircleInfo,
} from '@fortawesome/free-solid-svg-icons';
import type { ScheduleListProps } from './types';
import type { Schedule } from './store/schedulesSlice';
import {
  ContentCard,
  ScheduleListWrapper,
  ScheduleCard,
  ScheduleCardHeader,
  ScheduleTimeRow,
  ActionBar,
  EditButton,
  DeleteButton,
  TitleIcon,
  TooltipIconWrap,
  EmptyState,
} from './styles';
import { formatTimeTo12Hour } from './utils';

const ScheduleList: React.FC<ScheduleListProps> = ({ schedules, onEdit, onDelete }) => {
  if (schedules.length === 0) {
    return (
      <ContentCard>
        <EmptyState>All the available schedu   les. See details, create, delete or update existing schedules.</EmptyState>
      </ContentCard>
    );
  }

  return (
    <ScheduleListWrapper>
      {schedules.map((schedule: Schedule) => (
        <ScheduleCard key={schedule.id}>
          <ScheduleCardHeader>
            <TitleIcon>
              <FontAwesomeIcon icon={faCalendarDays} />
            </TitleIcon>
            {schedule.day_names.length > 0 ? (
              schedule.day_names.join(', ')
            ) : (
              <Tooltip title="No specific days, applies to all days">
                <span>
                  All Days
                  <TooltipIconWrap>
                    <FontAwesomeIcon icon={faCircleInfo} />
                  </TooltipIconWrap>
                </span>
              </Tooltip>
            )}
          </ScheduleCardHeader>
          <ScheduleTimeRow>
            <TitleIcon>
              <FontAwesomeIcon icon={faClock} />
            </TitleIcon>
            {formatTimeTo12Hour(schedule.start_time)} – {formatTimeTo12Hour(schedule.end_time)}
          </ScheduleTimeRow>
          <ActionBar>
            <EditButton
              type="default"
              icon={<FontAwesomeIcon icon={faPenToSquare} />}
              onClick={() => onEdit(schedule)}
            >
              Edit Schedule
            </EditButton>
            <DeleteButton
              type="primary"
              danger
              icon={<FontAwesomeIcon icon={faTrash} />}
              onClick={() => onDelete(schedule.id)}
            >
              Delete
            </DeleteButton>
          </ActionBar>
        </ScheduleCard>
      ))}
    </ScheduleListWrapper>
  );
};

export default React.memo(ScheduleList);
